<div class="container-fluid">
  @if (this.activeRoute === 'admin-cluster') {
    <app-cluster-selector
      [cluster]="cluster"
      [clusters]="clusters"
      (selected)="searchByCluster($event)"
    ></app-cluster-selector>
  }

  <div class="card p-3">
    <h4 class="mb-0">{{ "Journal d'action" | translate }}s</h4>
    <hr />
    <div class="row">
      <div class="col-md-2">
        <div class="form-group">
          <label>
            <b>{{ 'Search' | translate }}</b>
          </label>
          <input
            #search
            class="form-control form-control-sm"
            type="text"
            placeholder="{{
              activeRoute === 'admin-cluster'
                ? ('PlaceholderJournalSearch' | translate)
                : ('PlaceholderAdminJournalSearch' | translate)
            }}"
            (input)="resetIndex()"
          />
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <label
            ><b>{{ 'Période' | translate }}</b></label
          >
          <div class="flex-align-items">
            <button
              app-date-range-selector
              [range]="periode"
              [ranges]="['15M', '1H', '4H', 'T', 'Y', '7d', '30d', '90d', '12months']"
              [timePicker]="true"
              (rangeChange)="onPeriodEmitted($event)"
              style="font-size: 14px; padding: 6px 14px"
              class="btn btn-sm btn-primary flex-align-items"
              id="date-range-selector-journal"
            >
              <i class="icofont icofont-ui-calendar mr-2"></i>
              <span></span>
              <div class="arrow-down"></div>
            </button>
            <button
              (click)="refreshLogs()"
              class="btn btn-primary btn-sm ml-3"
              title="{{ 'Refresh' | translate }}"
              style="height: 30px"
            >
              <i class="icon-reload"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="journal-table table table-striped table-bordered table-xs">
        <thead>
          <tr>
            <th class="expand-button"></th>
            <th class="date">Date</th>
            @if (isAdmin) {
              <th class="contract">{{ 'Contract.column' | translate }}</th>
            }
            <th class="cluster">Cluster</th>
            <th class="author">{{ 'Auteur' | translate }}</th>
            <th class="entity">{{ 'Entité' | translate }}</th>
            <th class="action">Action</th>
            <th class="site">{{ 'Hôte' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-template
            ngFor
            let-event
            [ngForOf]="
              trackingEvents
                | paginate
                  : {
                      itemsPerPage: pageSize,
                      currentPage: page,
                      totalItems: totalItems,
                    }
            "
          >
            <tr>
              <td>
                <button class="btn-dark" (click)="event.showDetail = !event.showDetail">
                  {{ event.showDetail ? '-' : '+' }}
                </button>
              </td>
              <td class="date">
                {{ event.dateAction | dateFormat }}
              </td>
              @if (isAdmin) {
                <td>
                  @if (event.contractNumber) {
                    <a [routerLink]="['/admin/contracts', event.contractNumber]">
                      <app-badge-organization [code]="event.contractNumber" type="contract" />
                    </a>
                  } @else {
                    -
                  }
                </td>
              }
              <td>
                @if (event.clusterName) {
                  {{ event.clusterName }}
                } @else {
                  -
                }
              </td>
              <td>{{ event.actionAuthorEmail ? event.actionAuthorEmail : event.actionAuthorDetail?.email }}</td>
              <td>{{ event.recordTable }}</td>
              <td>{{ event.action }}</td>
              <td>{{ event.siteTrackedName }}</td>
            </tr>
            <tr *ngIf="event.showDetail">
              <td colspan="8" style="padding: 10px 20px">
                <div class="flex-align-items">
                  <div style="flex-basis: 45%">
                    <json-viewer [json]="event.recordBefore" [expanded]="true"></json-viewer>
                  </div>
                  <i style="flex-basis: 10%; font-size: 35px; color: #333" class="fa fa-long-arrow-right"></i>
                  <div style="flex-basis: 45%">
                    <json-viewer [json]="event.record" [expanded]="true"></json-viewer>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
          <tr *ngIf="trackingEvents?.length === 0">
            <td class="text-center h6" colspan="8">
              {{ 'NoData' | translate }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-md-12">
      <pagination-controls
        class="pull-right"
        (pageChange)="changePage($event)"
        previousLabel="{{ 'Previous' | translate }}"
        nextLabel="{{ 'Next' | translate }}"
      ></pagination-controls>
    </div>
  </div>
</div>
